import {
  Avatar,
  Badge,
  Box,
  Card,
  CardActions,
  CardContent,
  Chip,
  CircularProgress,
  Divider,
  FormControl,
  ListItem,
  ListItemAvatar,
  ListItemText,
  MenuItem,
  Select,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  TableSortLabel,
  TextField,
  Typography,
  Grid,
  Button,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  DialogContentText,
  FormGroup,
  FormControlLabel,
  Checkbox
} from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { makeStyles, withStyles } from "@material-ui/styles";
import { captureException } from "@sentry/react";
import clsx from "clsx";
import moment from "moment";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import PerfectScrollbar from "react-perfect-scrollbar";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { clearToastAction, toastAction } from "../../../../actions";
import api from "../../../../utils/api";
import getAvatarStyle from "../../../../utils/getAvatarStyle";
import getInitials from "../../../../utils/getInitials";
import Loader from "../../../../utils/loader";

const useStyles = makeStyles(theme => ({
  root: {},
  content: {
    padding: 0
  },
  inner: {
    minWidth: 700
  },
  nameCell: {
    display: "flex",
    alignItems: "center"
  },
  avatar: {
    height: 42,
    width: 42,
    marginRight: theme.spacing(1)
  },
  actions: {
    padding: theme.spacing(1),
    justifyContent: "flex-end"
  },
  capitalize: {
    textTransform: "capitalize"
  },
  chipButton: {
    paddingLeft: 12,
    paddingRight: 12
  },
  tableCell: {
    paddingLeft: 8,
    paddingRight: 8
  },
  bold: {
    fontWeight: "bold"
  },
  requested: {
    backgroundColor: "coral"
  },
  accepted: {
    backgroundColor: "green"
  },
  checkedIn: {
    backgroundColor: "forestgreen"
  },
  checkedOut: {
    backgroundColor: "grey"
  },
  declined: {
    backgroundColor: "red"
  },
  cancelled: {
    backgroundColor: "brown"
  },
  filterTextField: {
    "&::placeholder": {
      color: "#000"
    },
    "&::-ms-input-placeholder ": {
      color: "#000"
    }
  }
}));

const columns = [
  {
    label: "Participant",
    dataType: "profile",
    field: "visitor|employee"
  },
  {
    label: "Type",
    dataType: "type",
    field: "type"
  },
  {
    label: "Meeting time",
    dataType: "datetimerange",
    field: "meeting.startTime&meeting.endTime"
  },
  {
    label: "Meeting purpose",
    dataType: "text",
    field: "meeting.purpose"
  },
  {
    label: "venue",
    dataType: "venue",
    field: "meeting.building.name&meeting.room.name"
  },
  {
    label: "Checkin time",
    dataType: "checkintime",
    field: "checkintime" //custome handled in renderData function
  },
  {
    label: "Checkout time",
    dataType: "checkouttime",
    field: "checkouttime" //custome handled in renderData function
  },
  {
    label: "status",
    dataType: "status",
    field: "status"
  }
];

const StyledBadge = withStyles(theme => ({
  badge: {
    right: -48,
    top: 10,
    border: `2px solid ${theme.palette.background.paper}`,
    padding: "0 4px"
  }
}))(Badge);

const Results = props => {
  const { className, ...rest } = props;
  const classes = useStyles();
  const user = useSelector(state => state.user);
  const orgSettings = useSelector(state => state.orgSettings);
  const [loading, setLoading] = useState(true);
  const [suggestionLoading, setSuggestionLoading] = useState(false);
  const [openSuggestion, setOpenSuggestion] = useState(false);
  const [suggestionList, setSuggestionList] = useState([]);
  const [roomList, setRoomList] = useState([]);
  const [filterEmail, setFilterEmail] = useState("");
  const [meetings, setMeetings] = useState([]);
  const [meetingCount, setMeetingCount] = useState(0);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [filters, setFilters] = useState({});
  const [currentSort, setCurrentSort] = useState({
    label: "Date & time",
    direction: "desc"
  });
  const [query, setQuery] = useState({
    search: ["businessAdmin", "superadmin", "admin"].includes(user.role)
      ? []
      : user.role === "visitor"
      ? [
          {
            key: "participant.visitorId",
            value: user.userId,
            comparison: "="
          }
        ]
      : [
          {
            key: "participant.employeeId",
            value: user.userId,
            comparison: "="
          }
        ],
    sort: { key: "participant.createdAt", order: "DESC" },
    skip: 0,
    take: 10
  });

  const [loadingReport, setloadingReport] = useState(false);
  const [reportModalopen, setreportModalopen] = useState(false);
  const [reportFields, setreportFields] = useState([
    { id: "name", title: "Name", status: false },
    { id: "phone", title: "Phone number", status: false },
    { id: "visitorCompany", title: "Company", status: false },
    { id: "hostname", title: "Host Name", status: false },
    { id: "hostemail", title: "Host Email", status: false },
    { id: "hostdepartment", title: "Host Department", status: false },
    { id: "type", title: "Type", status: false },
    { id: "purpose", title: "Purpose of visit", status: false },
    { id: "startTime", title: "Meeting Start Time", status: false },
    { id: "endTime", title: "Meeting End Time", status: false },
    { id: "room", title: "Room", status: false },
    { id: "building", title: "Building", status: false },
    { id: "createdAt", title: "Scheduled Time", status: false },
    { id: "checkInTime", title: "Entry Time", status: false },
    { id: "checkOutTime", title: "Exit Time", status: false },
    { id: "checkOutType", title: "Checkout Type", status: false },
    { id: "totalVisitors", title: "Total Visitors", status: false },
    { id: "questions", title: "Survey Questions", status: false }
  ]);

  const dispatch = useDispatch();
  useEffect(() => {
    handleQuery();
  }, [page, rowsPerPage]);

  useEffect(() => {
    (async () => {
      try {
        const availablerooms = await api(
          "POST",
          "room/find",
          {
            search: [],
            sort: { key: "room.createdAt", order: "ASC" }
          },
          true
        );
        setRoomList(availablerooms);
      } catch (error) {
        captureException(error);
      }
    })();
  }, []);

  useEffect(() => {
    if (!openSuggestion) {
      setSuggestionList([]);
    } else {
      setSuggestionLoading(true);
      (async () => {
        try {
          var data = await api(
            "POST",
            "meeting/searchUsersWithKeyword",
            { keyword: filterEmail, organizationId: user.organizationId },
            true
          );
          var suggestions = [...data.employee, ...data.visitor];

          setSuggestionList(suggestions);
          setSuggestionLoading(false);
        } catch (error) {
          captureException(error);
        }
      })();
    }
  }, [openSuggestion, filterEmail]);

  const renderFilterColumns = (column, i) => {
    switch (column.dataType) {
      case "profile":
        return (
          <TableCell key={i} style={{ paddingLeft: 8, paddingRight: 8 }}>
            <Autocomplete
              fullWidth
              open={openSuggestion}
              blurOnSelect
              clearOnBlur
              noOptionsText={"No user found"}
              options={suggestionList}
              loading={suggestionLoading}
              onOpen={() => {
                setOpenSuggestion(true);
              }}
              onClose={() => {
                setOpenSuggestion(false);
              }}
              onChange={(event, newValue) => {
                if (newValue) {
                  setQuery({
                    ...query,
                    search: [
                      ...query.search.filter(
                        item =>
                          item.key !== "participant.visitorId" &&
                          item.key !== "participant.employeeId"
                      ),
                      {
                        key: newValue.role
                          ? "participant.employeeId"
                          : "participant.visitorId",
                        value: newValue.id,
                        comparison: "="
                      }
                    ]
                  });
                  setFilters({ ...filters, Participant: newValue.name });
                }
              }}
              filterOptions={(options, state) => options}
              getOptionLabel={option => {
                return option.name;
              }}
              renderOption={item => (
                <ListItem dense disableGutters style={{ overflowX: "hidden" }}>
                  <ListItemAvatar>
                    <Avatar style={getAvatarStyle(item.email)}>
                      {getInitials(item.name)}
                    </Avatar>
                  </ListItemAvatar>

                  <ListItemText
                    primary={
                      <StyledBadge
                        badgeContent={item.role ? item.role : "visitor"}
                        color={item.role ? "primary" : "secondary"}
                      >
                        <Typography variant="h5">{item.name}</Typography>
                      </StyledBadge>
                    }
                    secondary={
                      <Typography variant="body2" color="textSecondary">
                        {item.role &&
                          item[orgSettings.employeePrimaryIdentifier]}
                        {!item.role &&
                          item[orgSettings.visitorPrimaryIdentifier]}
                      </Typography>
                    }
                  />
                </ListItem>
              )}
              renderInput={params => (
                <TextField
                  {...params}
                  className={classes.filterTextField}
                  placeholder="Search user by email or phone number"
                  variant="outlined"
                  onChange={e => {
                    setFilterEmail(e.target.value);
                  }}
                  value={filterEmail}
                  size="small"
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <React.Fragment>
                        {suggestionLoading ? (
                          <CircularProgress color="inherit" size={20} />
                        ) : null}
                        {params.InputProps.endAdornment}
                      </React.Fragment>
                    )
                  }}
                />
              )}
            />
          </TableCell>
        );
      case "venue":
        return (
          <TableCell key={i} style={{ paddingLeft: 8, paddingRight: 8 }}>
            <FormControl
              variant="outlined"
              style={{ width: "100%" }}
              size="small"
            >
              <Select
                id="building"
                defaultValue=""
                displayEmpty
                onChange={e => {
                  setQuery({
                    ...query,
                    search: [
                      ...query.search.filter(
                        item => item.key !== "meeting.roomId"
                      ),
                      {
                        key: "meeting.roomId",
                        value: e.target.value,
                        comparison: "="
                      }
                    ]
                  });
                  const theRoom = roomList.find(
                    room => room.id === e.target.value
                  );
                  setFilters({
                    ...filters,
                    Room: theRoom.name + ", " + theRoom.building.name
                  });
                }}
                autoWidth
              >
                <MenuItem value="" disabled>
                  Filter by venue
                </MenuItem>
                {roomList.map(room => {
                  return (
                    <MenuItem value={room.id} key={room.id}>
                      {room.name}
                      {", "}
                      {room.building.name}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
          </TableCell>
        );
      case "datetimerange":
        return (
          <TableCell key={i} style={{ paddingLeft: 8, paddingRight: 8 }}>
            <TextField
              type="date"
              size="small"
              margin="none"
              variant="outlined"
              placeholder="Filter by date"
              onChange={e => {
                setQuery({
                  ...query,
                  search: [
                    ...query.search.filter(
                      item => item.key !== "meeting.startTime"
                    ),
                    {
                      key: "meeting.startTime",
                      value: moment(e.target.value)
                        .endOf("day")
                        .utc()
                        .format("MM-DD-YYYY HH:mm"),
                      comparison: "<="
                    },
                    {
                      key: "meeting.startTime",
                      value: moment(e.target.value)
                        .startOf("day")
                        .utc()
                        .format("MM-DD-YYYY HH:mm"),
                      comparison: ">"
                    }
                  ]
                });
                setFilters({
                  ...filters,
                  Date: e.target.value
                });
              }}
              required
              fullWidth
            />
          </TableCell>
        );
      case "status":
        return (
          <TableCell key={i} style={{ paddingLeft: 8, paddingRight: 8 }}>
            <FormControl
              variant="outlined"
              style={{ width: "100%" }}
              size="small"
            >
              <Select
                id="status"
                defaultValue=""
                displayEmpty
                onChange={e => {
                  setQuery({
                    ...query,
                    search: [
                      ...query.search.filter(
                        item => item.key !== "participant.status"
                      ),
                      {
                        key: "participant.status",
                        value: e.target.value,
                        comparison: "="
                      }
                    ]
                  });
                  setFilters({
                    ...filters,
                    Status:
                      e.target.value.charAt(0).toUpperCase() +
                      e.target.value.slice(1)
                  });
                }}
                autoWidth
              >
                <MenuItem value="" disabled>
                  Filter by status
                </MenuItem>
                <MenuItem value="requested">Requested</MenuItem>
                <MenuItem value="accepted">Accepted</MenuItem>
                <MenuItem value="checkedIn">CheckedIn</MenuItem>
                <MenuItem value="checkedOut">CheckedOut</MenuItem>
                <MenuItem value="declined">Declined</MenuItem>
                <MenuItem value="cancelled">Cancelled</MenuItem>
              </Select>
            </FormControl>
          </TableCell>
        );
      case "type":
        return (
          <TableCell key={i} style={{ paddingLeft: 8, paddingRight: 8 }}>
            <FormControl
              variant="outlined"
              style={{ width: "100%" }}
              size="small"
            >
              <Select
                id="type"
                defaultValue=""
                displayEmpty
                onChange={e => {
                  setQuery({
                    ...query,
                    search: [
                      ...query.search.filter(
                        item => item.key !== "participant.type"
                      ),
                      {
                        key: "participant.type",
                        value: e.target.value,
                        comparison: "="
                      }
                    ]
                  });
                  setFilters({
                    ...filters,
                    Type:
                      e.target.value.charAt(0).toUpperCase() +
                      e.target.value.slice(1)
                  });
                }}
                autoWidth
              >
                <MenuItem value="" disabled>
                  Filter by type
                </MenuItem>
                <MenuItem value="employee">Employee</MenuItem>
                <MenuItem value="visitor">Visitor</MenuItem>
              </Select>
            </FormControl>
          </TableCell>
        );
      case "text":
        return (
          <TableCell key={i} style={{ paddingLeft: 8, paddingRight: 8 }}>
            <TextField
              type="text"
              className={classes.filterTextField}
              size="small"
              margin="none"
              variant="outlined"
              placeholder="Filter by purpose"
              required
              fullWidth
              onChange={e => {
                setQuery({
                  ...query,
                  search: [
                    ...query.search.filter(
                      item => item.key !== "meeting.purpose"
                    ),
                    {
                      key: "meeting.purpose",
                      value: e.target.value,
                      comparison: "LIKE"
                    }
                  ]
                });
                setFilters({
                  ...filters,
                  Purpose: e.target.value
                });
              }}
            />
          </TableCell>
        );
      default:
        return (
          <TableCell
            key={i}
            style={{ paddingLeft: 8, paddingRight: 8 }}
          ></TableCell>
        );
    }
  };
  const renderDataColumns = (data, columns) => {
    const type = data.employeeId ? "employee" : "visitor";
    return columns.map((item, i) => {
      var dataField;
      if (item.field.includes("|")) {
        item.field.split("|").forEach(item => {
          dataField =
            dataField || item.split(".").reduce((ox, ix) => ox[ix], data);
        });
      } else if (item.field.includes("&")) {
        try {
          item.field.split("&").forEach((item, index) => {
            if (index === 0)
              dataField =
                item.split(".").reduce((ox, ix) => ox[ix], data) || "";
            else
              dataField =
                dataField +
                  ", " +
                  item.split(".").reduce((ox, ix) => ox[ix], data) || "";
          });
        } catch (error) {
          dataField = "";
        }
      } else {
        dataField = item.field.split(".").reduce((ox, ix) => ox[ix], data);
      }
      switch (item.dataType) {
        case "profile":
          return (
            <TableCell size="small" className={classes.tableCell} key={i}>
              <ListItem disableGutters dense>
                <ListItemAvatar>
                  <Avatar style={getAvatarStyle(dataField?.email)}>
                    {getInitials(dataField?.name)}
                  </Avatar>
                </ListItemAvatar>
                <ListItemText
                  primary={
                    <Typography variant="h5" className={classes.capitalize}>
                      {dataField?.name}
                    </Typography>
                  }
                  secondary={
                    <Typography variant="body2" color="textSecondary">
                      {dataField &&
                        dataField?.role &&
                        dataField[orgSettings.employeePrimaryIdentifier]}
                      {dataField &&
                        !dataField?.role &&
                        dataField[orgSettings.visitorPrimaryIdentifier]}
                    </Typography>
                  }
                />
              </ListItem>
            </TableCell>
          );
        case "venue":
          return (
            <TableCell size="small" className={classes.tableCell} key={i}>
              {dataField.split(", ")[0]} <br />{" "}
              <b>{dataField.split(", ")[1]}</b>
            </TableCell>
          );
        case "datetimerange":
          const times = dataField.split(", ");
          const date = moment
            .utc(new Date(parseInt(times[0])).toISOString())
            .local()
            .format("Do MMM YYYY");
          const start = moment
            .utc(new Date(parseInt(times[0])).toISOString())
            .local()
            .format("LT");
          const end = moment
            .utc(new Date(parseInt(times[1])).toISOString())
            .local()
            .format("LT");
          return (
            <TableCell size="small" className={classes.tableCell} key={i}>
              {date} <br /> <b>{start + " - " + end}</b>
            </TableCell>
          );
        case "datetime":
          return dataField ? (
            <TableCell size="small" className={classes.tableCell} key={i}>
              <b>
                {moment
                  .utc(new Date(parseInt(dataField)).toISOString())
                  .local()
                  .format("LT")}
              </b>{" "}
              {moment
                .utc(new Date(parseInt(dataField)).toISOString())
                .local()
                .format("Do MMM YYYY")}
            </TableCell>
          ) : (
            <TableCell size="small" className={classes.tableCell} key={i}>
              Not Available
            </TableCell>
          );
        case "checkintime":
          dataField = data.meeting.activities.find(aitem => {
            return (
              aitem.visitorId === data.visitorId &&
              aitem.eventDescription === "visitor checkedIn"
            );
          })?.createdAt;
          return dataField ? (
            <TableCell size="small" className={classes.tableCell} key={i}>
              <b>
                {moment
                  .utc(new Date(parseInt(dataField)).toISOString())
                  .local()
                  .format("LT")}
              </b>{" "}
              {moment
                .utc(new Date(parseInt(dataField)).toISOString())
                .local()
                .format("Do MMM YYYY")}
            </TableCell>
          ) : (
            <TableCell size="small" className={classes.tableCell} key={i}>
              Not Available
            </TableCell>
          );
        case "checkouttime":
          dataField = data.meeting.activities.find(aitem => {
            return (
              aitem.visitorId === data.visitorId &&
              aitem.eventDescription === "visitor checkedOut"
            );
          })?.createdAt;
          return dataField ? (
            <TableCell size="small" className={classes.tableCell} key={i}>
              <b>
                {moment
                  .utc(new Date(parseInt(dataField)).toISOString())
                  .local()
                  .format("LT")}
              </b>{" "}
              {moment
                .utc(new Date(parseInt(dataField)).toISOString())
                .local()
                .format("Do MMM YYYY")}
            </TableCell>
          ) : (
            <TableCell size="small" className={classes.tableCell} key={i}>
              Not Available
            </TableCell>
          );
        case "status":
          return (
            <TableCell
              size="small"
              key={i}
              className={clsx(classes.capitalize, classes.tableCell)}
            >
              <Chip
                label={dataField}
                color="primary"
                size="small"
                className={classes[dataField]}
              />
            </TableCell>
          );
        default:
          return (
            <TableCell
              size="small"
              className={[classes.tableCell, classes.capitalize]}
              key={i}
            >
              {dataField}
            </TableCell>
          );
      }
    });
  };
  const handleChangePage = (event, page) => {
    setQuery({ ...query, skip: page * rowsPerPage });
    setPage(page);
  };

  const handleChangeRowsPerPage = event => {
    setQuery({ ...query, skip: 0, take: event.target.value });
    setRowsPerPage(event.target.value);
  };

  const handleSort = label => {
    var direction = "asc";
    var key;
    if (currentSort.label === label && currentSort.direction === "asc")
      direction = "desc";
    const order = direction.toUpperCase();

    switch (label.toLowerCase()) {
      case "meeting time":
        key = "meeting.startTime";
        break;
      case "meeting purpose":
        key = "meeting.purpose";
        break;
      case "status":
        key = "participant.status";
        break;
      case "status":
        key = "participant.status";
        break;
      case "venue":
        key = "room.name";
        break;
      default:
        break;
    }
    handleQuery({ ...query, sort: { key, order }, skip: 0 });
    setQuery({ ...query, sort: { key, order }, skip: 0 });
    setCurrentSort({ label, direction });
  };

  const handleDeleteChip = async key => {
    switch (key) {
      case "Participant":
        setQuery({
          ...query,
          search: [
            ...query.search.filter(
              item =>
                item.key !== "participant.visitorId" &&
                item.key !== "participant.employeeId"
            )
          ]
        });
        setFilterEmail("");
        break;
      case "Venue":
        setQuery({
          ...query,
          search: [
            ...query.search.filter(item => item.key !== "meeting.roomId")
          ]
        });
        break;
      case "Meeting Time":
        setQuery({
          ...query,
          search: [
            ...query.search.filter(item => item.key !== "meeting.startTime")
          ]
        });
        break;
      case "Status":
        setQuery({
          ...query,
          search: [
            ...query.search.filter(item => item.key !== "participant.status")
          ]
        });
        break;
      case "Type":
        setQuery({
          ...query,
          search: [
            ...query.search.filter(item => item.key !== "participant.type")
          ]
        });
        break;
      case "Meeting Purpose":
        setQuery({
          ...query,
          search: [
            ...query.search.filter(item => item.key !== "meeting.purpose")
          ]
        });
        break;
      default:
        break;
    }

    let allFilters = filters;
    delete allFilters[key];
    Object.keys(allFilters).length === 0 &&
      handleQuery({
        ...query,
        search: ["businessAdmin", "superadmin", "admin"].includes(user.role)
          ? []
          : user.role === "visitor"
          ? [
              {
                key: "participant.visitorId",
                value: user.userId,
                comparison: "="
              }
            ]
          : [
              {
                key: "participant.employeeId",
                value: user.userId,
                comparison: "="
              }
            ]
      });
    setFilters({ ...allFilters });
  };

  const handleRowClick = id => {
    // navigate(id);
  };

  const handleQuery = async customQuery => {
    dispatch(
      toastAction({
        status: true,
        message: "Loading...",
        type: "info",
        noIcon: true
      })
    );
    try {
      const meetingCountData = customQuery
        ? await api("POST", "participant/findCount", customQuery, true)
        : await api("POST", "participant/findCount", query, true);
      const meetingData = customQuery
        ? await api("POST", "participant/find", customQuery, true)
        : await api("POST", "participant/find", query, true);
      setMeetingCount(meetingCountData);
      setMeetings(meetingData);
      setLoading(false);
      dispatch(clearToastAction({}));
    } catch (error) {
      dispatch(clearToastAction({}));
      captureException(error);
    }
  };

  const handleReport = () => {
    setreportModalopen(true);
  };

  const changeReportFields = (e, index) => {
    let oldFields = reportFields;
    oldFields[index].status = e.target.checked;
    setreportFields(oldFields);
  };

  const downloadReport = async () => {
    setloadingReport(true);
    const meetingReportUrl = await api(
      "POST",
      "participant/findReport",
      {
        query: query,
        fields: reportFields
          .filter(fitem => fitem.status)
          .map(fitem => {
            return { id: fitem.id, title: fitem.title };
          })
      },
      true
    );
    setloadingReport(false);
    setreportModalopen(false);
    window.open(meetingReportUrl, "_blank");
  };

  return loading ? (
    <Loader />
  ) : (
    <div {...rest} className={clsx(classes.root, className)}>
      <Grid
        container
        direction="row"
        alignItems="center"
        justify="space-between"
      >
        <Grid item>
          <Typography color="textSecondary" gutterBottom variant="h4" component="span">
            Report
          </Typography>
          <Typography
            color="textSecondary"
            variant="h5"
            component="span"
            style={{ lineHeight: 2.4 }}
          >
            &nbsp;&nbsp;From &nbsp;&nbsp;
          </Typography>
          <TextField
            type="date"
            size="small"
            margin="none"
            variant="outlined"
            placeholder="Start Date"
            onChange={e => {
              const customQuery = {
                ...query,
                search: [
                  ...query.search.filter(
                    item => item.key !== "meeting.startTime"
                  ),
                  {
                    key: "meeting.startTime",
                    value: moment(e.target.value)
                      .startOf("day")
                      .utc()
                      .format("MM-DD-YYYY HH:mm"),
                    comparison: ">="
                  }
                ]
              };
              setQuery(customQuery);
              handleQuery(customQuery);
            }}
          />
          <Typography
            color="textSecondary"
            variant="h5"
            component="span"
            style={{ lineHeight: 2.4 }}
          >
            &nbsp;&nbsp;to&nbsp;&nbsp;
          </Typography>
          <TextField
            type="date"
            size="small"
            margin="none"
            variant="outlined"
            placeholder="End Date"
            onChange={e => {
              const customQuery = {
                ...query,
                search: [
                  ...query.search.filter(
                    item => item.key !== "meeting.endTime"
                  ),
                  {
                    key: "meeting.endTime",
                    value: moment(e.target.value)
                      .endOf("day")
                      .utc()
                      .format("MM-DD-YYYY HH:mm"),
                    comparison: "<="
                  }
                ]
              };
              setQuery(customQuery);
              handleQuery(customQuery);
            }}
          />
        </Grid>
        {user.role !== "businessAdmin" && (
          <Grid item>
            <Button onClick={handleReport} variant="outlined" color="primary">
              Generate Report
            </Button>
          </Grid>
        )}
      </Grid>

      <Typography color="textSecondary" gutterBottom variant="caption">
        {meetingCount} Results found. Page {page + 1} of{" "}
        {Math.ceil(meetingCount / rowsPerPage)}
      </Typography>
      <Card>
        <Divider />
        <CardContent className={classes.content}>
          <PerfectScrollbar>
            <div className={classes.inner}>
              <Table>
                <TableHead>
                  <TableRow>
                    {columns.map((col, i) => (
                      <TableCell className={classes.capitalize} key={i}>
                        {col.dataType.toLowerCase() !== "profile" &&
                          col.dataType.toLowerCase() !== "checkouttime" &&
                          col.dataType.toLowerCase() !== "checkintime" && (
                            <TableSortLabel
                              active={currentSort.label === col.label}
                              direction={currentSort.direction}
                              onClick={() => handleSort(col.label)}
                            >
                              {col.label}
                            </TableSortLabel>
                          )}
                        {(col.dataType.toLowerCase() === "profile" ||
                          col.dataType.toLowerCase() === "checkouttime" ||
                          col.dataType.toLowerCase() === "checkintime") &&
                          col.label}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow>{columns.map(renderFilterColumns)}</TableRow>
                  {Object.keys(filters).length > 0 && (
                    <TableRow selected>
                      <TableCell colSpan={columns.length} align="center">
                        <Typography variant="h6" component="p">
                          Selected filters: &nbsp;
                        </Typography>
                        {Object.keys(filters).map((filter, i) => {
                          return (
                            <React.Fragment key={i}>
                              <Chip
                                variant="outlined"
                                color="primary"
                                onDelete={() => {
                                  handleDeleteChip(filter);
                                }}
                                label={
                                  <>
                                    <b className={classes.capitalize}>
                                      {filter}
                                    </b>
                                    : {filters[filter]}
                                  </>
                                }
                              />
                              &nbsp; &nbsp;
                            </React.Fragment>
                          );
                        })}
                        <Chip
                          color="primary"
                          icon={<SearchIcon />}
                          className={classes.chipButton}
                          clickable
                          onClick={() => handleQuery()}
                          label={<b>Search</b>}
                        />
                      </TableCell>
                    </TableRow>
                  )}
                  {meetings.map(meeting => (
                    <TableRow
                      hover
                      key={meeting.id}
                      onClick={() => handleRowClick(meeting.id)}
                    >
                      {renderDataColumns(meeting, columns)}
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </div>
          </PerfectScrollbar>
        </CardContent>
        <CardActions className={classes.actions}>
          <TablePagination
            component="div"
            count={meetingCount}
            onChangePage={handleChangePage}
            onChangeRowsPerPage={handleChangeRowsPerPage}
            page={page}
            rowsPerPage={rowsPerPage}
            rowsPerPageOptions={[5, 10, 25]}
          />
        </CardActions>
      </Card>
      <Dialog
        open={reportModalopen}
        onClose={e => setreportModalopen(true)}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">Generate Report</DialogTitle>
        {loadingReport ? (
          <Box px={5}>
            <Loader />
          </Box>
        ) : (
          <>
            <DialogContent>
              <DialogContentText>
                To generate report, please select the data columns you want on
                your report.
              </DialogContentText>
              <FormGroup>
                {reportFields.map((fitem, index) => (
                  <FormControlLabel
                    key={index}
                    control={
                      <Checkbox
                        onChange={e => changeReportFields(e, index)}
                        label={fitem.title}
                      />
                    }
                    label={fitem.title}
                  />
                ))}
              </FormGroup>
            </DialogContent>
            <DialogActions>
              <Button onClick={e => setreportModalopen(false)} color="primary">
                Cancel
              </Button>
              <Button onClick={downloadReport} color="primary">
                Export
              </Button>
            </DialogActions>
          </>
        )}
      </Dialog>
    </div>
  );
};

Results.propTypes = {
  className: PropTypes.string,
  meetings: PropTypes.array.isRequired
};

Results.defaultProps = {
  meetings: []
};

export default Results;
